import { render, staticRenderFns } from "./IcoBookShelf.vue?vue&type=template&id=8894a306"
import script from "./IcoBookShelf.vue?vue&type=script&lang=js"
export * from "./IcoBookShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports